const mediaItems = [
  {
    title: '热门新番抢先看',
    desc: '羞羞歪歪漫画最新连载速递，每周第一时间同步更新',
    tag: '新番速递',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20style%20illustration%20with%20warm%20coral%20pink%20and%20golden%20amber%20tones%2C%20energetic%20action%20scene%20with%20flowing%20ink%20lines%2C%20dramatic%20shadows%20and%20lighting%2C%20modern%20comic%20art%20aesthetic%2C%20clean%20composition%20with%20vibrant%20warm%20colors%2C%20soft%20gradient%20background&width=800&height=500&seq=media-comic-01&orientation=landscape',
  },
  {
    title: '经典漫画全收录',
    desc: '经典完结漫画全集，羞羞歪歪漫画全部章节免费畅读',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20manga%20style%20illustration%20with%20warm%20sepia%20and%20coral%20tones%2C%20classic%20character%20silhouette%20in%20flowing%20ink%20brush%20style%2C%20elegant%20traditional%20comic%20aesthetic%20blended%20with%20modern%20design%2C%20soft%20atmospheric%20lighting%2C%20clean%20warm%20background&width=800&height=500&seq=media-comic-02&orientation=landscape',
  },
  {
    title: '恋爱甜漫合集',
    desc: '甜到发齁的恋爱漫画，羞羞歪歪漫画竖屏阅读更沉浸',
    tag: '恋爱甜漫',
    img: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20manga%20style%20illustration%20with%20soft%20pink%20and%20peach%20tones%2C%20gentle%20cherry%20blossom%20petals%20floating%2C%20warm%20intimate%20atmosphere%2C%20delicate%20ink%20lines%20and%20watercolor%20texture%2C%20dreamy%20soft%20focus%20background%2C%20elegant%20romantic%20composition&width=800&height=500&seq=media-comic-03&orientation=landscape',
  },
  {
    title: '热血战斗专题',
    desc: '高燃战斗场景，羞羞歪歪漫画无删减完整呈现每一格细节',
    tag: '热血战斗',
    img: 'https://readdy.ai/api/search-image?query=A%20powerful%20action%20manga%20style%20illustration%20with%20fiery%20orange%20and%20crimson%20tones%2C%20dynamic%20battle%20pose%20with%20dramatic%20speed%20lines%2C%20intense%20energy%20burst%20effects%2C%20bold%20ink%20brush%20strokes%20with%20modern%20comic%20aesthetic%2C%20warm%20glowing%20background&width=800&height=500&seq=media-comic-04&orientation=landscape',
  },
  {
    title: '悬疑惊悚剧场',
    desc: '烧脑悬疑漫画，羞羞歪歪漫画下拉式阅读营造紧张氛围',
    tag: '悬疑剧场',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20atmospheric%20manga%20style%20illustration%20with%20deep%20warm%20amber%20and%20shadow%20tones%2C%20dramatic%20lighting%20with%20silhouettes%2C%20suspenseful%20mood%20with%20ink%20splashes%2C%20modern%20thriller%20comic%20aesthetic%2C%20soft%20gradient%20background%20with%20warm%20and%20dark%20contrast&width=800&height=500&seq=media-comic-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          精彩视频推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all shadow-lg">
                    <i className="ri-play-fill text-2xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/85 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-medium text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}